import { Formik, Form } from 'formik'
import { useState } from 'react'
import { AuthSchema } from '@validations'
import Column from '@components/column'
import Button from '@components/button'
import Fields from '@components/fields'
import { Document } from '@apis'
import { store, Actions } from '@store'
import { useSelector } from 'react-redux'
const Signature = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const signature = user?.documents?.find(
    (document: any) => document?.type == 'Signature',
  )
  const [initialValues] = useState({
    type: 'Signature',
    name: 'Signature',
    signature: !!signature?.id ? signature?.infos?.image : null,
  })
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    setLoading(true)
    const payload: any = {
      name: values?.name,
      image: {
        base64: values?.signature?.base64,
        extension: values?.signature?.extension,
      },
    }
    if (signature?.id) {
      payload.id = signature?.id
      payload.oldPath = signature?.infos?.image
    }
    await Document.createOrUpdate({
      data: {
        type: values?.type,
        documents: [payload],
      },
    })
      .then((resp) => {
        store.dispatch(
          Actions.update('user', {
            ...user,
            documents: resp,
          }),
        )
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      enableReinitialize
      validationSchema={AuthSchema.signatureValidationSchema}
    >
      {({ handleSubmit }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <Column rowGap={20}>
              <Fields.Signature name="signature" />
              <Column alignItems="flex-end">
                <Button
                  type="submit"
                  title="Submit"
                  height={40}
                  loading={loading}
                />
              </Column>
            </Column>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Signature
